<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card header-tag="header" footer-tag="footer">
                    <div slot="header">
                        <strong> Route Management</strong> 
                    </div>

                    <b-row>
                        <b-col md="12" >                
                            <div>
                                <div>
                                    <b-row >
                                        <b-col md="7">
                                            <b-row>
                                                <b-col md="3">
                                                    <label><b>Upload CSV File</b></label>&nbsp;<span style="color: red;">*</span>
                                                </b-col>
                                                <b-col md="8">
                                                    <b-form-group>
                                                        <b-form-file type="file" v-model="file"
                                                        :state="Boolean(file)" @change="selectcsvFiletoUpload($event)"
                                                        placeholder="Upload CSV File" accept=".csv"
                                                        ></b-form-file>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col md="5">
                                            <b-row>
                                                <b-col md="2">
                                                    <b-button variant="primary" :pressed.sync="myToggle" @click="uploadcsv()" :disabled="isReadOnly">Submit</b-button>
                                                </b-col>
                                                <b-col md="2">
                                                    <b-button variant="danger"  @click="clearcsv()">Clear</b-button>
                                                </b-col>
                                                <b-col md="4">
                                                    <a  :href="downlaodcsv+'sysusermasterid='+Usersysuser" target="_blank"><b-button variant="primary">Download CSV</b-button></a>
                                                </b-col>
                                                
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </div>

                                <div class="route-border">
                                </div>

                <!-- //Route management table -->
                                <div id="successfulcard" style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);" class="mb-1">
                                    <!-- display:none; -->
                                    <b-tabs content-class="mt-3" lazy justified >
                                        <b-tab title="Accepted Records" show >
                                            <!-- Accepted Records Start-->
                                            <b-row>
                                                <b-col sm="12" class="text-right  margin-bottom =-13px;" >
                                                    <b>Total Records :<span style="color:red;"> {{ routertotalRows }}</span></b>   &nbsp;&nbsp;&nbsp;
                                                </b-col>

                                                <b-col sm="12" style="overflow:auto;">  
                                                    <strong>Accepted Record</strong>
                                                    <b-table  show-empty responsive :busy="isBusy"   :items="RoutesdetailsList"  
                                                        :fields="Routesdetailsfields" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" class="routetable">                                            
                                                            <div slot="table-busy" class="text-center text-danger my-2">
                                                            <b-spinner class="align-middle"></b-spinner>
                                                            <strong>Loading...</strong>
                                                            </div>
                                                            <template slot="isactive" slot-scope="row">
                                                                <span  v-if="row.item.isactive === '1'">Active</span>
                                                                <span  v-if="row.item.isactive === '0'">In Active</span>
                                                            </template>
                                                    </b-table>
                                                </b-col>
                                            </b-row>
                                            <b-col>
                                                <paginate 
                                                    :page-count="noofpages"
                                                    :page-range="10"
                                                    :margin-pages="2"
                                                    :click-handler="clickCallback"
                                                    :prev-text="'Prev'"
                                                    :next-text="'Next'"
                                                    :container-class="'pagination'"
                                                    :page-class="'page-item'">
                                                </paginate>
                                            </b-col>
                                            <!-- Accepted Records End-->
                                        </b-tab>
                                        
                                        <b-tab title="Rejected Records" show>
                                            <!-- Rejected Records Start-->
                                            <b-row>
                                                <b-col sm="12" class="text-right  margin-bottom =-13px;" >
                                                    <b>Total Records :<span style="color:red;"> {{ totalrejectrow }}</span></b>   &nbsp;&nbsp;&nbsp;
                                                </b-col>

                                                <b-col sm="12" style="overflow:auto;">  
                                                    <!-- <strong>Rejected Record</strong> -->
                                                    <b-table  show-empty responsive :busy="isBusy"   :items="RejecttotalRecord" :fields="rejectedfields" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" class="routetable">                                            
                                                        <div slot="table-busy" class="text-center text-danger my-2">
                                                        <b-spinner class="align-middle"></b-spinner>
                                                        <strong>Loading...</strong>
                                                        </div>
                                                    
                                                    </b-table>
                                                </b-col>
                                            </b-row>
                                            <!-- Rejected Records End-->
                                        </b-tab>
                                    </b-tabs>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <div id="overlay" >
                      <div class="loader"></div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
   data() {
      return {
            file1: null,
            selectcsvFile:'',
            file:'',
            selectFiletype:'',
            myToggle: false,
            RejecttotalRecord :[],
            rejectedfields: [
                { key: 'route', label: 'Route', sortable: true},
                { key: 'sourcepincode', label: 'Source Pincode', sortable: true},
                { key: 'destinationpincode', label: 'Destination Pincode', sortable: true},
                { key: 'otherhubid', label: 'Rejected Hub', sortable: true},
            ],
            acceptedRecord :[],
            acceptedfields: [
                { key: 'route', label: 'Route', sortable: true},
                { key: 'sourcepincode', label: 'Source Pincode', sortable: true},
                { key: 'destinationpincode', label: 'Destination Pincode', sortable: true},
                { key: 'stringhubs', label: 'Accepted Hub', sortable: true},
            ],
            downlaodcsv :'',
            Routesdetailsfields: [
                { key: 'routeid', label: 'Route Id', sortable: true},
                { key: 'sourcepincode', label: 'Source Pincode', sortable: true},
                { key: 'destinationpincode', label: 'Destination Pincode', sortable: true},
                { key: 'alhubids', label: 'Next Hub Id', sortable: true},
                { key: 'isactive', label: 'Active / Inactive', sortable: true},
                { key: 'createdby', label: 'Created By', sortable: true},
                { key: 'createddate', label: 'Created Date', sortable: true},
            ],
            totalRows :0,
            RoutesdetailsList :[],
            routertotalRows :0,
            // perPage: 20,
            // currentPage: 1,
            Usersysuser :'',
            totalrejectrow :0,
            noofpages:'',
            pageNum:1,
            listingpageno:1,
            accessBody:[],
            isReadOnly:false,
        }
   },
   created() {
    var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.userType=userInfo.user_type;
      this.Usersysuser=userInfo.sysusermasterid;
    this.user_id = userInfo.sysusermasterid;
    this.routerDetailsdata(this.pageNum);
    const csvurl = `${CONSTANTS.MIGRATION_API_URL}/downloadRouteCSV?`
    this.downlaodcsv=csvurl;
    this.accessBody = userInfo.body;
        this.ischeckbodyvalidation();
   },

    methods: {
        ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=='Route Details' && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='Route Details' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
        selectcsvFiletoUpload :function (event){
            this.selectcsvFile= event.target.files[0];
            console.log("HHH",this.selectcsvFile);

            this.selectFiletype= event.target.files[0].type;
            console.log("selectFiletype",this.selectFiletype);
        },

        clearcsv :function () {
            this.file ='';
            // document.getElementById("successfulcard").style.display='none';

        },

        uploadcsv :function (){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            document.getElementById("overlay").style.display = "block";
            if(this.selectFiletype == 'text/csv'){

                let data = new FormData();
                            data.append('file', this.selectcsvFile)
                            data.append('createdby', `${userInfo.userfirstname}` + ' ' + `${userInfo.userlastname}`)
                            data.append('sysusermasterid', `${userInfo.sysusermasterid}`)
                        let config = {
                            header : {
                            'Content-Type' : 'multipart/form-data'
                            }
                            }
                            console.log("Config",config);
                        // return false;
                        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/uploadRouteHubCsvPincodes`,data,{ header : {
                            'Content-Type' : 'multipart/form-data'
                            } }).then(result => {
                            console.log("YYY",result);
                            if (result.body.returnmsg === 'Successful') {
                                console.log("result.body.returnmsg",result.body.returnmsg)
                                this.RejecttotalRecord = result.body.rejectedRecord;
                            this.totalrejectrow = this.RejecttotalRecord.length;
                            console.log("rejectedRecord",this.RejecttotalRecord,this.totalrejectrow)
                            this.AcceptedtotalRecord = result.body.acceptedRecords;
                            console.log("acceptedRecord",this.AcceptedtotalRecord )
                            this.resultMsg=result.body.returnmsg;
                            // alert("inn");
                            this.$fire({
                                    text:result.body.returnvalue,
                                type: "success",
                                timer: 30000
                                }); 
                                document.getElementById("overlay").style.display = "none";
                                this.file ='';
                    this.selectcsvFile='';
                    this.selectFiletype='';
                    this.routerDetailsdata(this.pageNum);
                }else{
                  this.file ='';
                this.$fire({
                            text:result.body.returnvalue,
                            type: "error",
                            timer: 30000
                            }); 
                            document.getElementById("overlay").style.display = "none";
                }
                })
                .catch(ex => {
                console.log("error", ex);
                });
            }
            else{
              document.getElementById("overlay").style.display = "none";
            this.file ='';
            this.$fire({
                        text:"Please Upload CSV File Only",
                        type: "error",
                        timer: 30000
                    }); 
            }
        },

        clickCallback (pageNum){
          this.listingpageno = pageNum;
            console.log("pageNum",this.listingpageno)
           this.routerDetailsdata(pageNum);
        },

        routerDetailsdata : function(pageNo){

            this.isBusy=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const obj={
                sysusermasterid:`${userInfo.sysusermasterid}`,
                pageno:`${pageNo}`,
            }
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getRoutesDetailsData`,obj).then(result => {
                    this.isBusy=false;
                    console.log("result",result)
                    if (result.body.returnmsg === "Successful") {
                        // alert("ok")
                    this.RoutesdetailsList=result.body.returnvalue;
                    console.log("RoutesdetailsList",this.RoutesdetailsList);
                    this.routertotalRows=result.body.totalcount;
                    this.noofpages=parseInt(this.routertotalRows)/100;
                    this.noofpages=Math.ceil( this.noofpages);
                    }else{
                        this.RoutesdetailsList=[];
                        this.routertotalRows=0;
                    }
                    }).catch(ex => {
                    console.log("error", ex);
                });
        }

    },
}
</script>

<style>
.routetable th, td {
    text-align: center;
}
.route-border {
    border-bottom: 1px solid #c9bebe;
    margin: 30px 0px 20px 0px;
}
</style>